import jQuery from 'js/jquery/jquery-1.12.4.js';

// Rails unobtrusive scripting adapter for jQuery
// https://github.com/rails/jquery-ujs
import 'js/jquery/jquery-ujs-2.1.2.js';

// Simple, lightweight jQuery plugin for reading, writing and deleting cookies
// https://github.com/carhartl/jquery-cookie
import 'js/jquery_plugins/jquery.cookie.js';

// Legacy file
// eslint-disable-next-line no-barrel-files/no-barrel-files
export default jQuery;
